// Initial Setup of api to API
import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import useQuery from 'app/hooks/useQuery';

export default function ManageQueryErrors(props) {

    const { enqueueSnackbar } = useSnackbar();

    let query = useQuery();

    const showQueryError = queryError => {

        switch (queryError) {
            case '901':
                enqueueSnackbar("You have successfully verified your email address.", {variant: 'success', autoHideDuration: 10000});
                break;
            case '902':
                enqueueSnackbar("You have successfully created an organization!.", {variant: 'success', autoHideDuration: 10000});
                break;
            case '904':
                enqueueSnackbar("You do not have access to this organization.", {variant: 'error', autoHideDuration: 10000});
                break;
            case '905':
                enqueueSnackbar("There is not an organization at this subdomain. Please try again.", {variant: 'error', autoHideDuration: 10000});
                break;
            default:
                enqueueSnackbar("Looks like you experienced an error. Please try again.", {variant: 'error'});
        }
    }

    // Om initial page load, let's see if a query error exists
    useEffect(() => {
        const queryError = query.get('caqe');

        if (queryError) {
            showQueryError(queryError);
            query.delete('caqe');
        }

    }, []);

    return null;
}
